import { useAuth } from "../authProvider";
import { Navigate } from "react-router-dom";

function PublicRoute({ children }) {
  const { currentUser } = useAuth();

  if (currentUser) {
    return <Navigate to="/dashboard" />;
  }

  return children;
}

export default PublicRoute;
